/**
 * This is a wrapper HOC that wraps component and adds className (+ other attributes)
 * 
 * This is the supported configurations:
 * 
 * className - Puts className on component
 * 
 * Support these extra elements:
 * 
 * extra.hide - Will wrap component with display:none
 * 
 */

import React from 'react'
import styled from 'styled-components'
import SummaryComponent from './SummaryComponent'
import isEmpty from 'lodash/isEmpty'

const Wrapper = styled.div`
    ${p=> ! p.noMargin && `margin-bottom:${p.theme.componentsMarginBottom};` }
    ${p=>p.hide && p.builder === false && 'display:none;'};
    ${p=>p.inlineCSS};
`

const withWrapper =  (Component,opt) => (props) => {
    const { extra = {},builder = false, isSummary = false,type, validationError } = props;
    const { noWrap = false, className = '', hasSummary = false, noMargin = false } = opt

    if( noWrap ) {
        return <Component {...props}/>
    }

    if( isSummary ) {
        if( ! hasSummary ) {
            return null
        }
        return <SummaryComponent {...props}/>
    }

    let _className = `${className} ${isEmpty(validationError) ? '' : 'validation-error'}`

    return (
        <Wrapper builder={builder} hide={extra.hide} inlineCSS={extra.css} className={_className} noMargin={noMargin}>
            <Component {...props}/>
        </Wrapper>
    )
}

export default withWrapper
